import {
  ProRadio,
  ProRadioProps,
  ProSwitch,
  ProText,
} from '@bedrock/eed-react';
import React from 'react';
import { FC } from 'react';
import { isNil } from 'lodash';

export const ProRadioBoolean: FC<Partial<ProRadioProps>> = (props) => {


  return (
    <ProRadio.Group
      {...props}
      fieldProps={{
        ...(props.fieldProps || {}),
        options: [
          { name: '是', value: true },
          { name: '否', value: false },
        ],
      }}
    />
  );
};
